/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Envelope = $root.Envelope = (() => {

    /**
     * Properties of an Envelope.
     * @exports IEnvelope
     * @interface IEnvelope
     * @property {number|null} [channel] 频道:
     * 0-error
     * 1-heartbeat
     * 2-large_trade
     * 3-notice
     * 4-trades
     * 5-orderBook
     * 6-orderBookCharts
     * 7-ticker
     * 8-exchange
     * 9-plate
     * 10-plate_history
     * 11-candle
     * 12-other
     * 13-personageCommunity
     * 14-hangBroadcast
     * @property {Uint8Array|null} [business] Envelope business
     */

    /**
     * Constructs a new Envelope.
     * @exports Envelope
     * @classdesc Represents an Envelope.
     * @implements IEnvelope
     * @constructor
     * @param {IEnvelope=} [properties] Properties to set
     */
    function Envelope(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * 频道:
     * 0-error
     * 1-heartbeat
     * 2-large_trade
     * 3-notice
     * 4-trades
     * 5-orderBook
     * 6-orderBookCharts
     * 7-ticker
     * 8-exchange
     * 9-plate
     * 10-plate_history
     * 11-candle
     * 12-other
     * 13-personageCommunity
     * 14-hangBroadcast
     * @member {number} channel
     * @memberof Envelope
     * @instance
     */
    Envelope.prototype.channel = 0;

    /**
     * Envelope business.
     * @member {Uint8Array} business
     * @memberof Envelope
     * @instance
     */
    Envelope.prototype.business = $util.newBuffer([]);

    /**
     * Creates a new Envelope instance using the specified properties.
     * @function create
     * @memberof Envelope
     * @static
     * @param {IEnvelope=} [properties] Properties to set
     * @returns {Envelope} Envelope instance
     */
    Envelope.create = function create(properties) {
        return new Envelope(properties);
    };

    /**
     * Encodes the specified Envelope message. Does not implicitly {@link Envelope.verify|verify} messages.
     * @function encode
     * @memberof Envelope
     * @static
     * @param {IEnvelope} message Envelope message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Envelope.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.channel);
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.business);
        return writer;
    };

    /**
     * Encodes the specified Envelope message, length delimited. Does not implicitly {@link Envelope.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Envelope
     * @static
     * @param {IEnvelope} message Envelope message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Envelope.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Envelope message from the specified reader or buffer.
     * @function decode
     * @memberof Envelope
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Envelope} Envelope
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Envelope.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Envelope();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.int32();
                    break;
                }
            case 2: {
                    message.business = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Envelope message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Envelope
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Envelope} Envelope
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Envelope.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Envelope message.
     * @function verify
     * @memberof Envelope
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Envelope.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isInteger(message.channel))
                return "channel: integer expected";
        if (message.business != null && message.hasOwnProperty("business"))
            if (!(message.business && typeof message.business.length === "number" || $util.isString(message.business)))
                return "business: buffer expected";
        return null;
    };

    /**
     * Creates an Envelope message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Envelope
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Envelope} Envelope
     */
    Envelope.fromObject = function fromObject(object) {
        if (object instanceof $root.Envelope)
            return object;
        let message = new $root.Envelope();
        if (object.channel != null)
            message.channel = object.channel | 0;
        if (object.business != null)
            if (typeof object.business === "string")
                $util.base64.decode(object.business, message.business = $util.newBuffer($util.base64.length(object.business)), 0);
            else if (object.business.length >= 0)
                message.business = object.business;
        return message;
    };

    /**
     * Creates a plain object from an Envelope message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Envelope
     * @static
     * @param {Envelope} message Envelope
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Envelope.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.channel = 0;
            if (options.bytes === String)
                object.business = "";
            else {
                object.business = [];
                if (options.bytes !== Array)
                    object.business = $util.newBuffer(object.business);
            }
        }
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = options.bytes === String ? $util.base64.encode(message.business, 0, message.business.length) : options.bytes === Array ? Array.prototype.slice.call(message.business) : message.business;
        return object;
    };

    /**
     * Converts this Envelope to JSON.
     * @function toJSON
     * @memberof Envelope
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Envelope.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Envelope
     * @function getTypeUrl
     * @memberof Envelope
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Envelope.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Envelope";
    };

    return Envelope;
})();

export const Candle = $root.Candle = (() => {

    /**
     * Properties of a Candle.
     * @exports ICandle
     * @interface ICandle
     * @property {number|Long|null} [currencyId] Candle currencyId
     * @property {number|Long|null} [timestamp] Candle timestamp
     * @property {string|null} [openPrice] Candle openPrice
     * @property {string|null} [highPrice] Candle highPrice
     * @property {string|null} [lowPrice] Candle lowPrice
     * @property {string|null} [closePrice] Candle closePrice
     * @property {number|null} [type] Candle type
     * @property {string|null} [change] Candle change
     * @property {string|null} [turnover] Candle turnover
     * @property {string|null} [change1h] Candle change1h
     * @property {string|null} [change24h] Candle change24h
     * @property {string|null} [change7d] Candle change7d
     * @property {string|null} [change30d] Candle change30d
     * @property {string|null} [changeYear] Candle changeYear
     * @property {string|null} [changeNow] Candle changeNow
     */

    /**
     * Constructs a new Candle.
     * @exports Candle
     * @classdesc Represents a Candle.
     * @implements ICandle
     * @constructor
     * @param {ICandle=} [properties] Properties to set
     */
    function Candle(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Candle currencyId.
     * @member {number|Long} currencyId
     * @memberof Candle
     * @instance
     */
    Candle.prototype.currencyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Candle timestamp.
     * @member {number|Long} timestamp
     * @memberof Candle
     * @instance
     */
    Candle.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Candle openPrice.
     * @member {string} openPrice
     * @memberof Candle
     * @instance
     */
    Candle.prototype.openPrice = "";

    /**
     * Candle highPrice.
     * @member {string} highPrice
     * @memberof Candle
     * @instance
     */
    Candle.prototype.highPrice = "";

    /**
     * Candle lowPrice.
     * @member {string} lowPrice
     * @memberof Candle
     * @instance
     */
    Candle.prototype.lowPrice = "";

    /**
     * Candle closePrice.
     * @member {string} closePrice
     * @memberof Candle
     * @instance
     */
    Candle.prototype.closePrice = "";

    /**
     * Candle type.
     * @member {number} type
     * @memberof Candle
     * @instance
     */
    Candle.prototype.type = 0;

    /**
     * Candle change.
     * @member {string} change
     * @memberof Candle
     * @instance
     */
    Candle.prototype.change = "";

    /**
     * Candle turnover.
     * @member {string} turnover
     * @memberof Candle
     * @instance
     */
    Candle.prototype.turnover = "";

    /**
     * Candle change1h.
     * @member {string} change1h
     * @memberof Candle
     * @instance
     */
    Candle.prototype.change1h = "";

    /**
     * Candle change24h.
     * @member {string} change24h
     * @memberof Candle
     * @instance
     */
    Candle.prototype.change24h = "";

    /**
     * Candle change7d.
     * @member {string} change7d
     * @memberof Candle
     * @instance
     */
    Candle.prototype.change7d = "";

    /**
     * Candle change30d.
     * @member {string} change30d
     * @memberof Candle
     * @instance
     */
    Candle.prototype.change30d = "";

    /**
     * Candle changeYear.
     * @member {string} changeYear
     * @memberof Candle
     * @instance
     */
    Candle.prototype.changeYear = "";

    /**
     * Candle changeNow.
     * @member {string} changeNow
     * @memberof Candle
     * @instance
     */
    Candle.prototype.changeNow = "";

    /**
     * Creates a new Candle instance using the specified properties.
     * @function create
     * @memberof Candle
     * @static
     * @param {ICandle=} [properties] Properties to set
     * @returns {Candle} Candle instance
     */
    Candle.create = function create(properties) {
        return new Candle(properties);
    };

    /**
     * Encodes the specified Candle message. Does not implicitly {@link Candle.verify|verify} messages.
     * @function encode
     * @memberof Candle
     * @static
     * @param {ICandle} message Candle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Candle.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.currencyId != null && Object.hasOwnProperty.call(message, "currencyId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.currencyId);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
        if (message.openPrice != null && Object.hasOwnProperty.call(message, "openPrice"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.openPrice);
        if (message.highPrice != null && Object.hasOwnProperty.call(message, "highPrice"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.highPrice);
        if (message.lowPrice != null && Object.hasOwnProperty.call(message, "lowPrice"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.lowPrice);
        if (message.closePrice != null && Object.hasOwnProperty.call(message, "closePrice"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.closePrice);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.type);
        if (message.change != null && Object.hasOwnProperty.call(message, "change"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.change);
        if (message.turnover != null && Object.hasOwnProperty.call(message, "turnover"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.turnover);
        if (message.change1h != null && Object.hasOwnProperty.call(message, "change1h"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.change1h);
        if (message.change24h != null && Object.hasOwnProperty.call(message, "change24h"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.change24h);
        if (message.change7d != null && Object.hasOwnProperty.call(message, "change7d"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.change7d);
        if (message.change30d != null && Object.hasOwnProperty.call(message, "change30d"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.change30d);
        if (message.changeYear != null && Object.hasOwnProperty.call(message, "changeYear"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.changeYear);
        if (message.changeNow != null && Object.hasOwnProperty.call(message, "changeNow"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.changeNow);
        return writer;
    };

    /**
     * Encodes the specified Candle message, length delimited. Does not implicitly {@link Candle.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Candle
     * @static
     * @param {ICandle} message Candle message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Candle.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Candle message from the specified reader or buffer.
     * @function decode
     * @memberof Candle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Candle} Candle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Candle.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Candle();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.currencyId = reader.int64();
                    break;
                }
            case 2: {
                    message.timestamp = reader.int64();
                    break;
                }
            case 3: {
                    message.openPrice = reader.string();
                    break;
                }
            case 4: {
                    message.highPrice = reader.string();
                    break;
                }
            case 5: {
                    message.lowPrice = reader.string();
                    break;
                }
            case 6: {
                    message.closePrice = reader.string();
                    break;
                }
            case 7: {
                    message.type = reader.int32();
                    break;
                }
            case 8: {
                    message.change = reader.string();
                    break;
                }
            case 9: {
                    message.turnover = reader.string();
                    break;
                }
            case 10: {
                    message.change1h = reader.string();
                    break;
                }
            case 11: {
                    message.change24h = reader.string();
                    break;
                }
            case 12: {
                    message.change7d = reader.string();
                    break;
                }
            case 13: {
                    message.change30d = reader.string();
                    break;
                }
            case 14: {
                    message.changeYear = reader.string();
                    break;
                }
            case 15: {
                    message.changeNow = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Candle message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Candle
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Candle} Candle
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Candle.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Candle message.
     * @function verify
     * @memberof Candle
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Candle.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.currencyId != null && message.hasOwnProperty("currencyId"))
            if (!$util.isInteger(message.currencyId) && !(message.currencyId && $util.isInteger(message.currencyId.low) && $util.isInteger(message.currencyId.high)))
                return "currencyId: integer|Long expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        if (message.openPrice != null && message.hasOwnProperty("openPrice"))
            if (!$util.isString(message.openPrice))
                return "openPrice: string expected";
        if (message.highPrice != null && message.hasOwnProperty("highPrice"))
            if (!$util.isString(message.highPrice))
                return "highPrice: string expected";
        if (message.lowPrice != null && message.hasOwnProperty("lowPrice"))
            if (!$util.isString(message.lowPrice))
                return "lowPrice: string expected";
        if (message.closePrice != null && message.hasOwnProperty("closePrice"))
            if (!$util.isString(message.closePrice))
                return "closePrice: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isInteger(message.type))
                return "type: integer expected";
        if (message.change != null && message.hasOwnProperty("change"))
            if (!$util.isString(message.change))
                return "change: string expected";
        if (message.turnover != null && message.hasOwnProperty("turnover"))
            if (!$util.isString(message.turnover))
                return "turnover: string expected";
        if (message.change1h != null && message.hasOwnProperty("change1h"))
            if (!$util.isString(message.change1h))
                return "change1h: string expected";
        if (message.change24h != null && message.hasOwnProperty("change24h"))
            if (!$util.isString(message.change24h))
                return "change24h: string expected";
        if (message.change7d != null && message.hasOwnProperty("change7d"))
            if (!$util.isString(message.change7d))
                return "change7d: string expected";
        if (message.change30d != null && message.hasOwnProperty("change30d"))
            if (!$util.isString(message.change30d))
                return "change30d: string expected";
        if (message.changeYear != null && message.hasOwnProperty("changeYear"))
            if (!$util.isString(message.changeYear))
                return "changeYear: string expected";
        if (message.changeNow != null && message.hasOwnProperty("changeNow"))
            if (!$util.isString(message.changeNow))
                return "changeNow: string expected";
        return null;
    };

    /**
     * Creates a Candle message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Candle
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Candle} Candle
     */
    Candle.fromObject = function fromObject(object) {
        if (object instanceof $root.Candle)
            return object;
        let message = new $root.Candle();
        if (object.currencyId != null)
            if ($util.Long)
                (message.currencyId = $util.Long.fromValue(object.currencyId)).unsigned = false;
            else if (typeof object.currencyId === "string")
                message.currencyId = parseInt(object.currencyId, 10);
            else if (typeof object.currencyId === "number")
                message.currencyId = object.currencyId;
            else if (typeof object.currencyId === "object")
                message.currencyId = new $util.LongBits(object.currencyId.low >>> 0, object.currencyId.high >>> 0).toNumber();
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
        if (object.openPrice != null)
            message.openPrice = String(object.openPrice);
        if (object.highPrice != null)
            message.highPrice = String(object.highPrice);
        if (object.lowPrice != null)
            message.lowPrice = String(object.lowPrice);
        if (object.closePrice != null)
            message.closePrice = String(object.closePrice);
        if (object.type != null)
            message.type = object.type | 0;
        if (object.change != null)
            message.change = String(object.change);
        if (object.turnover != null)
            message.turnover = String(object.turnover);
        if (object.change1h != null)
            message.change1h = String(object.change1h);
        if (object.change24h != null)
            message.change24h = String(object.change24h);
        if (object.change7d != null)
            message.change7d = String(object.change7d);
        if (object.change30d != null)
            message.change30d = String(object.change30d);
        if (object.changeYear != null)
            message.changeYear = String(object.changeYear);
        if (object.changeNow != null)
            message.changeNow = String(object.changeNow);
        return message;
    };

    /**
     * Creates a plain object from a Candle message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Candle
     * @static
     * @param {Candle} message Candle
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Candle.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.currencyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.currencyId = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            object.openPrice = "";
            object.highPrice = "";
            object.lowPrice = "";
            object.closePrice = "";
            object.type = 0;
            object.change = "";
            object.turnover = "";
            object.change1h = "";
            object.change24h = "";
            object.change7d = "";
            object.change30d = "";
            object.changeYear = "";
            object.changeNow = "";
        }
        if (message.currencyId != null && message.hasOwnProperty("currencyId"))
            if (typeof message.currencyId === "number")
                object.currencyId = options.longs === String ? String(message.currencyId) : message.currencyId;
            else
                object.currencyId = options.longs === String ? $util.Long.prototype.toString.call(message.currencyId) : options.longs === Number ? new $util.LongBits(message.currencyId.low >>> 0, message.currencyId.high >>> 0).toNumber() : message.currencyId;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
        if (message.openPrice != null && message.hasOwnProperty("openPrice"))
            object.openPrice = message.openPrice;
        if (message.highPrice != null && message.hasOwnProperty("highPrice"))
            object.highPrice = message.highPrice;
        if (message.lowPrice != null && message.hasOwnProperty("lowPrice"))
            object.lowPrice = message.lowPrice;
        if (message.closePrice != null && message.hasOwnProperty("closePrice"))
            object.closePrice = message.closePrice;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.change != null && message.hasOwnProperty("change"))
            object.change = message.change;
        if (message.turnover != null && message.hasOwnProperty("turnover"))
            object.turnover = message.turnover;
        if (message.change1h != null && message.hasOwnProperty("change1h"))
            object.change1h = message.change1h;
        if (message.change24h != null && message.hasOwnProperty("change24h"))
            object.change24h = message.change24h;
        if (message.change7d != null && message.hasOwnProperty("change7d"))
            object.change7d = message.change7d;
        if (message.change30d != null && message.hasOwnProperty("change30d"))
            object.change30d = message.change30d;
        if (message.changeYear != null && message.hasOwnProperty("changeYear"))
            object.changeYear = message.changeYear;
        if (message.changeNow != null && message.hasOwnProperty("changeNow"))
            object.changeNow = message.changeNow;
        return object;
    };

    /**
     * Converts this Candle to JSON.
     * @function toJSON
     * @memberof Candle
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Candle.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Candle
     * @function getTypeUrl
     * @memberof Candle
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Candle.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Candle";
    };

    return Candle;
})();

export { $root as default };
